
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface EmptyTabContentProps {
  message: string;
}

const EmptyTabContent = ({ message }: EmptyTabContentProps) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-10">
        <p className="text-gray-500">{message}</p>
      </CardContent>
    </Card>
  );
};

export default EmptyTabContent;
